<div class="category-card product-card" [ngClass]="getCardClasses()" *ngIf="variant">
    <div class="image-container">
        <img [src]="image" [alt]="title" class="card-image" />
    </div>

    <div class="content">
        <div class="text-content">
            <div class="text-wrapper">
                <h3 class="card-title transition-colors">{{ title }}</h3>
                <p class="card-description">{{ description }}</p>
            </div>
        </div>

        <a [routerLink]="target" [queryParams]="queryParams" routerLinkActive="router-link-active">
            <app-button [variant]="variant | mapCardToButtonVariant" buttonClass="explore-btn" class="group/btn">
                <span>Explore {{ title }}</span>
                <mat-icon
                    aria-hidden="false"
                    aria-label="arrow icon"
                    fontIcon="arrow_forward"
                    class="arrow-icon group-hover/btn:translate-x-1"
                ></mat-icon>
            </app-button>
        </a>
    </div>
</div>
